import {Link} from 'react-router-dom';
import CloudInitTable, {type CloudInitDataRef} from "../../components/data_table/CloudInitTable.tsx";
import {useEffect, useRef} from "react";
import {swal_util} from "../../lib/SwalUtil.ts";

import {frontBaseUrl} from "../../build_constants.ts";
import {Navbar} from "../../components/Navbar.tsx";
import {useTranslation} from "react-i18next";

interface ContentProps {
    toggleSidebar: () => void;
}

const CloudInitPage = ({toggleSidebar}: ContentProps) => {
    const {t} = useTranslation();
    const dataTableRef = useRef<CloudInitDataRef>(null);

    useEffect(() => {
        if (dataTableRef.current) {
            dataTableRef.current.redraw();
        }
        // translation 객체가 변경되면 화면을 다시 그림
    }, [dataTableRef, t]);

    async function onClickCloudInitDelete() {
        const selectedRows = dataTableRef.current?.getSelectedData() || [];
        if (selectedRows.length > 0) {
            const data = await swal_util.show_question(t("CloudInit.YamlDeleteTitle"), t("CloudInit.YamlDeleteQuestion"))
            if (data.isConfirmed) {
                selectedRows.forEach((data) => {
                    dataTableRef.current?.onClickDelete(data.name);
                });
            } else return false;
        } else {
            swal_util.show_warning(t("CloudInit.NoYamlSelected")).finally();
        }
    }

    return (
        <main className="d-block col ps-2 pt-3 min-vh-100">
            <Navbar toggleSidebar={toggleSidebar}/>
            <article className="blueshift_main" id="wrapper">
                <div className="p-4 pt-2">
                    <div className="row">
                        <h6 className="text-primary pt-2 col-6">Cloud-init YAML</h6>
                        <div className="text-end col-6">
                            <Link to={`${frontBaseUrl}/cloud_init/edit`}
                                  className="button_blue text-decoration-none rounded-3 mx-1 py-2"
                                  style={{fontSize: "14px"}}>{t("common.create")}</Link>
                            <button type="button" className="button_red rounded-3 py-2"
                                    style={{fontSize: "14px"}} onClick={onClickCloudInitDelete}>
                                {t("common.delete")}
                            </button>
                        </div>
                    </div>
                    <div className="text-center align-items-center">
                        <CloudInitTable ref={dataTableRef}/>
                    </div>
                </div>
            </article>
        </main>
    );
}

export default CloudInitPage;